import '../static/Slider.css';
import * as React from "react";
import React__default, { memo, useId, useMemo, useState, useRef, useCallback } from "react";
import clsx from "clsx";
import { A11y, Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { b as Button } from "./Button.hIh6dJaA.mjs";
import { u as useReducedMotion } from "./useReducedMotion.BDSQ_zcf.mjs";
const SvgChevronLeft1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentcolor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M13.354 2.146a.5.5 0 0 1 0 .708L6.207 10l7.147 7.146a.5.5 0 0 1-.708.708l-7.5-7.5a.5.5 0 0 1 0-.708l7.5-7.5a.5.5 0 0 1 .708 0", clipRule: "evenodd" }));
const SvgChevronRight1Px = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentcolor", viewBox: "0 0 20 20", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M7.146 2.146a.5.5 0 0 0 0 .708L14.293 10l-7.147 7.146a.5.5 0 0 0 .708.708l7.5-7.5a.5.5 0 0 0 0-.708l-7.5-7.5a.5.5 0 0 0-.708 0", clipRule: "evenodd" }));
const slider = `_slider_bfcf0fa`;
const controls = `_controls_63f6967`;
const arrow = `_arrow_3387a16`;
const pagination = `_pagination_c8890da`;
const paginationTimer = `_paginationTimer_6a53c31`;
const styles = { slider, controls, arrow, pagination, paginationTimer };
const SliderArrowInner = ({
  direction,
  className,
  id,
  ...props
}) => /* @__PURE__ */ React__default.createElement(
  Button,
  {
    id: `${id}-${direction}`,
    "data-testid": `ui-slider-${direction}`,
    "data-navigation": direction,
    variant: "transparent",
    size: "lg",
    rounded: true,
    "aria-label": direction === "prev" ? "Previous Slide" : "Next Slide",
    className: clsx(styles.arrow, className),
    ...props
  },
  direction === "prev" ? /* @__PURE__ */ React__default.createElement(SvgChevronLeft1Px, null) : /* @__PURE__ */ React__default.createElement(SvgChevronRight1Px, null)
);
const SliderArrow = memo(SliderArrowInner);
const SliderControls = ({
  className,
  id,
  navigation,
  pagination: pagination2,
  autoplayTimer,
  ...props
}) => {
  if (!navigation && !pagination2) {
    return null;
  }
  return /* @__PURE__ */ React__default.createElement("div", { className: clsx(className, styles.controls), ...props }, navigation && /* @__PURE__ */ React__default.createElement(SliderArrow, { direction: "prev", id }), pagination2 && /* @__PURE__ */ React__default.createElement(
    "div",
    {
      id: `${id}-pagination`,
      "data-testid": "ui-slider-pagination",
      "data-pagination": true,
      className: clsx(styles.pagination, {
        [styles.paginationTimer]: Boolean(autoplayTimer)
      })
    }
  ), navigation && /* @__PURE__ */ React__default.createElement(SliderArrow, { direction: "next", id }));
};
const Slider = ({
  className,
  autoplayTimer,
  slides,
  modules = [],
  navigation,
  pagination: pagination2,
  onSwiper,
  speed,
  ...props
}) => {
  const id = useId();
  const prefersReducedMotion = useReducedMotion();
  const showTimer = useMemo(
    () => prefersReducedMotion ? false : Boolean(autoplayTimer),
    [autoplayTimer, prefersReducedMotion]
  );
  const [swiperRef, setSwiperRef] = useState();
  const sliderRef = useRef(null);
  const onAutoplayTimeLeft = useCallback(
    (_swiper, _timeLeft, progress) => {
      if (!sliderRef.current)
        return;
      sliderRef.current.style.setProperty(
        "--slider-pagination-progress",
        // limit progress to decimal cases
        1 - Math.ceil(progress * 100) / 100 + ""
      );
    },
    []
  );
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: clsx(styles.slider, className),
      "data-testid": "ui-slider",
      ref: sliderRef
    },
    /* @__PURE__ */ React__default.createElement(
      Swiper,
      {
        ...props,
        id,
        watchOverflow: true,
        speed: prefersReducedMotion ? 1 : speed,
        onSwiper: (swiper) => {
          setSwiperRef(swiper);
          if (onSwiper) {
            onSwiper(swiper);
          }
        },
        modules: [
          A11y,
          ...navigation ? [Navigation] : [],
          ...pagination2 ? [Pagination] : [],
          ...showTimer ? [Autoplay] : [],
          ...modules
        ],
        ...pagination2 && {
          pagination: {
            el: `[id="${id}-pagination"]`,
            clickable: true
          }
        },
        ...navigation && {
          navigation: {
            nextEl: `[id="${id}-next"]`,
            prevEl: `[id="${id}-prev"]`
          }
        },
        ...showTimer && {
          autoplay: {
            delay: autoplayTimer,
            disableOnInteraction: false
          },
          onAutoplayTimeLeft
        }
      },
      slides.map((slide, index) => /* @__PURE__ */ React__default.createElement(SwiperSlide, { key: index }, slide))
    ),
    !(swiperRef == null ? void 0 : swiperRef.isLocked) && /* @__PURE__ */ React__default.createElement(
      SliderControls,
      {
        id,
        navigation,
        pagination: pagination2,
        autoplayTimer: showTimer ? autoplayTimer : void 0
      }
    )
  );
};
export {
  Slider as S
};
//# sourceMappingURL=Slider.CQuUmyJh.mjs.map
